import { useNavigate } from "react-router-dom";
import Fondo from "../assets/ssss.png"
import { motion } from "framer-motion";

const QuienesSomos = () => {
    const navigate = useNavigate();

    return (
        <div className="w-full h-auto md:h-[75vh] grid grid-cols-1 md:grid-cols-2 md:px-36">
            <motion.div
                initial={{ opacity: 0, x: -100 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1.5, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
                className="w-full h-[55vh] md:h-full bg-contain bg-center bg-no-repeat flex items-center justify-start"
                style={{ backgroundImage: `url(${Fondo})` }} 
            />
            <div className="relative w-full h-full flex flex-col justify-center text-left px-4 md:px-0">
                <div className="bg-estra p-24 text-white md:absolute md:-left-16 ">
                <h1 className="font-bold text-4xl">¿Por qué nosotros?</h1>
                    <p className="text-lg text-justify">
                        Nuestro equipo multidisciplinario se dedica a garantizar que usted reciba una atención personal y un servicio de primera calidad.
                        Nos preocupamos por usted.
                    </p>
                    <button className="text-white bg-trasparent border border-white p-2 px-4 rounded-full mx-auto" onClick={()=>navigate("/about")}>
                        Concertar una cita
                    </button>
                </div>
            </div>
        </div>
    );
};
export default QuienesSomos;